__webpack_require__.p = "https://ventahood.variantconfigurator.com/";